import { baseApi } from './baseApi';

export interface AMC {
  id: string;
  name: string;
  isRTA: boolean;
  fundCode: string;
  useExternalUpiWebhook: boolean;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
  merchantConfigs?: MerchantGatewayConfig[];
  assets?: Asset[];
  logoPath?: string;
}

export interface GetAMCsMeta {
  limit: number;
  page: number;
  searchTerm: string;
  total: number;
  totalPages: number;
}

export interface MerchantGatewayConfig {
  id?: string;
  merchantId: string;
  checksumKey?: string;
  amc: { id: string };
  aggregator: 'Billdesk1' | 'Billdesk2' | 'CamsPay' | 'RazorPay' | 'ePay';
  bankId?: string;
  clientId?: string;
}

export interface Asset {
  id: string;
  name: string;
  apiKey: string;
  code: string;
  isActive: boolean;
  amc: { id: string };
  createdAt?: string;
  updatedAt?: string;
}

export const amcApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAMCs: builder.query<AMC[], void>({
      query: () => '/amcs',
      providesTags: ['AMC'],
    }),
    getAMC: builder.query<AMC, string>({
      query: (id) => `/amcs/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'AMC', id }],
    }),
    createAMC: builder.mutation<AMC, Partial<AMC>>({
      query: (body) => ({
        url: '/amcs',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AMC'],
    }),
    updateAMC: builder.mutation<AMC, { id: string; updates: Partial<AMC> }>({
      query: ({ id, updates }) => ({
        url: `/amcs/${id}`,
        method: 'PUT',
        body: updates,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'AMC', id }, 'AMC'],
    }),
    deleteAMC: builder.mutation<void, string>({
      query: (id) => ({
        url: `/amcs/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AMC'],
    }),
    getAMCLogs: builder.query<any, string>({
      query: (id) => `/amcs/${id}/logs`,
    }),
    
    disableAMC: builder.mutation<void, string>({
    query: (id) => ({
        url: `/amcs/disable/${id}`,
        method: 'POST',
    }),
      invalidatesTags: ['AMC'],
    }),

    enableAMC: builder.mutation<void, string>({
    query: (id) => ({
        url: `/amcs/enable/${id}`,
        method: 'POST',
    }),
      invalidatesTags: ['AMC'],
    }),

    getAMCList: builder.query<AMC[], void>({
      query: () => '/amcs/list',
    }),
  }),
});

export const {
  useGetAMCsQuery,
  useGetAMCQuery,
  useCreateAMCMutation,
  useUpdateAMCMutation,
  useDeleteAMCMutation,
  useGetAMCLogsQuery,
  useDisableAMCMutation,
  useEnableAMCMutation,
  useGetAMCListQuery,
} = amcApi;
